import { FormControl } from '@angular/forms';
import { isValidNumber } from 'libphonenumber-js';
import * as Punycode from 'punycode';

export class CustomDSValidators {

    static maxPortNumber8444(control: FormControl) {
        if (!control.value) {
            return null;
        }
        return control.value <= 8444 ? null : { max_port_844: true };
    }

    static cnameExistsName(control: FormControl) {
        return { cname_exists_name: true };
    }

    static default_ttl(control: FormControl) {
        if (!control.value) {
            return null;
        }
        return control.value && control.value.toString().match(/^[0-9]+$/) ? null : { default_ttl: true };
    }

    static domain_name(control: FormControl) {
        if (control.value) {
            return control.value.match(/^([a-z0-9]{1,60}([\.\_\-]?)){1,7}\.[a-z]{2,11}\.?$/i) ||
                Punycode.toASCII(control.value).match(/^xn\-\-([a-z0-9]+\-?(\-|\.)?){1,56}([a-z]{2,11}\.?)?$/i) ? null : { domain_name: true };
        }
        return null;
    }

    static recordPreference(control: FormControl) {
        return control.value && control.value.toString().match(/^[0-9]{2}$/) ? null : { preference: true };
    }

    static number(control: FormControl) {
        return control.value && control.value.toString().match(/^[0-9]+$/) ? null : { number: true };
    }

    static record_value(control: FormControl) {
        return control.value.match(/^([a-z0-9]{1,60}([\.\_\-]?)){1,7}\.[a-z]{2,11}\.?$/i) ||
            Punycode.toASCII(control.value).match(/^xn\-\-([a-z0-9]+\-?(\-|\.)?){1,56}([a-z]{2,11}\.?)?$/i) ? null : { record_value: true };
    }

    static target_name(control: FormControl) {
        return control.value.match(/^([a-z0-9]{1,60}([\.\_\-]?)){1,7}\.[a-z]{2,11}\.?$/i) ||
            Punycode.toASCII(control.value).match(/^xn\-\-([a-z0-9]+\-?(\-|\.)?){1,56}([a-z]{2,11}\.?)?$/i) ? null : { target_name: true };
    }

    static nip(control: FormControl) {
        let nipWithoutDashes = control.value.replace(/-/g, "");
        const regex = /^[0-9]{10}$/;
        if (regex.test(nipWithoutDashes) === false) {
            return { nip: true };
        } else {
            let digits = ("" + nipWithoutDashes).split("");
            let checksum = (6 * parseInt(digits[0]) + 5 * parseInt(digits[1])
                + 7 * parseInt(digits[2]) + 2 * parseInt(digits[3]) + 3 * parseInt(digits[4])
                + 4 * parseInt(digits[5]) + 5 * parseInt(digits[6]) + 6 * parseInt(digits[7])
                + 7 * parseInt(digits[8])) % 11;

            return (parseInt(digits[9]) === checksum) ? null : { nip: true };
        }
    }

    static polishPhoneNumber(control: FormControl) {
        const regex = /^$|^(?:\(?\+?48)?(?:[-\.\(\)\s]*(\d)){9}\)?$/;
        return regex.test(control.value) ? null : { polishPhoneNumber: true };
    }

    static polishPostalCode(control: FormControl) {
        const regex = /^$|^[0-9]{2}-[0-9]{3}$/;
        return regex.test(control.value) ? null : { polishPostalCode: true };
    }

    static IP(control: FormControl) {
        const regex = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/;
        return regex.test(control.value) ? null : { IP: true };
    }

    static IPv6(control: FormControl) {
        const regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/;
        return regex.test(control.value) ? null : { IPv6: true };
    }

    static IPWithMask(control: FormControl) {
        const regex = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))(\/[0-9]{1,2})?$/;
        return regex.test(control.value) ? null : { IPWithMask: true };
    }

    static revDNS(control: FormControl) {
        const regex = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;
        return regex.test(control.value) ? null : { revDNS: true };
    }

    static noBlank(control: FormControl) {
        const regex = /^\s*$/;
        return (control.value.length && regex.test(control.value)) ? { noBlank: true } : null;
    }

    static internationalPhoneNumber(regionCodeControl: FormControl) {
        return (control: FormControl) => {
            return (control.value === '') ? null : isValidNumber(control.value, regionCodeControl.value) ? null : { internationalPhoneNumber: true };
        };
    }

    static staffEmail(control: FormControl) {
        if (control.value == null) {
            return null;
        }
        const email = control.value.split('/');
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isValid = false;
        email.forEach(element => {
            isValid = EMAIL_REGEXP.test(element);
        });
        return isValid ? null : { email: true };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/custom-validators.ts